var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoCH = function SvgLogoCH(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 65,
    viewBox: "0 0 265 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.113647 56.5169L55.6278 64.0964L63.2597 8.96321L7.74556 1.36914L0.113647 56.5169Z",
    fill: "#FF329B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3452 30.0029C11.9416 40.109 19.0326 49.4164 29.1939 50.8249C39.3551 52.2188 48.7415 45.1765 50.1451 35.0705L13.3452 30.0029Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3691 17.5153C24.0182 20.0418 21.6643 21.8133 19.1203 21.4648C16.5764 21.1163 14.7927 18.7786 15.1435 16.252C15.4944 13.7255 17.8483 11.9541 20.3923 12.3025C22.9363 12.651 24.72 14.9888 24.3691 17.5153Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0166 21.2326C51.6657 23.7591 49.3118 25.5306 46.7678 25.1821C44.2238 24.8336 42.4401 22.4958 42.791 19.9693C43.1419 17.4428 45.4958 15.6713 48.0398 16.0198C50.5984 16.3683 52.3675 18.7061 52.0166 21.2326Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M192.32 0.897409L136.812 8.55566L144.523 63.6829L200.031 56.0246L192.32 0.897409Z",
    fill: "#6AD300"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.799 13.6878L149.924 34.604L170.985 50.3704L186.86 29.4542L165.799 13.6878Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M208.699 8.08167L208.594 63.6069L264.503 63.7105L264.607 8.18527L208.699 8.08167Z",
    fill: "#009EEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M227.375 21.8862C227.39 24.4417 225.314 26.5036 222.741 26.5181C220.182 26.5326 218.091 24.4708 218.077 21.9152C218.062 19.3597 220.138 17.2978 222.711 17.2833C225.285 17.2688 227.361 19.3306 227.375 21.8862Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M255.257 22.0458C255.271 24.6013 253.195 26.6632 250.622 26.6777C248.049 26.6922 245.973 24.6304 245.958 22.0748C245.943 19.5193 248.019 17.4429 250.593 17.4429C253.166 17.4429 255.242 19.5047 255.257 22.0458Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M245.987 35.927C246.002 41.0091 241.85 45.1618 236.747 45.1764C231.63 45.1909 227.463 41.0671 227.448 35.9851L218.135 36.0141C218.164 46.2218 226.513 54.4548 236.776 54.4257C247.04 54.3967 255.33 46.0911 255.301 35.8979L245.987 35.927Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M128.219 7.90332H72.1782V63.5592H128.219V7.90332Z",
    fill: "#F28529"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M100.206 51.2898C108.975 51.2898 116.084 44.2298 116.084 35.5209C116.084 26.8119 108.975 19.752 100.206 19.752C91.4367 19.752 84.3279 26.8119 84.3279 35.5209C84.3279 44.2298 91.4367 51.2898 100.206 51.2898Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoCH);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-c-h.d87f9734b4acaac6a9286b60bb659f55.svg";